module.exports = __webpack_public_path__ + "static/media/CT_2019_30445_1598A.e7519ab6.png";